import { AppReducer } from './app-reducer';
import { ChangePasswordDialogProgress } from '../types';
import { State, InitialState } from '../state';

const emptyUserSettings: State['User']['loggedInUser'] = {
    user: {
        fName: '-',
        lName: '-',
        email: '-',
        phone: '-',
    },
    notification: {
        emailenabled: false,
        smsenabled: false,
    },
    session: { sessionEnabled: false },
};

export const userSettingsReducer: AppReducer<'User'> = (state = InitialState.User, action): typeof state => {
    switch (action.type) {
        case 'UserSettings/Load/Started':
            return {
                ...state,
                loading: true,
                success: false,
                message: '',
                loggedInUser: emptyUserSettings,
            };
        case 'UserSettings/Load/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
                loggedInUser: action.payload.data,
            };
        case 'UserSettings/Load/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                message: '',
                //loggedInUser: emptyUserSettings,
            };

        case 'UserSettings/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
                updateSuccess: false,
                message: '',
                loggedInUser: emptyUserSettings,
            };
        case 'UserSettings/Reset':
            return {
                ...state,
                loading: false,
                success: false,
                updateSuccess: false,
                message: '',
                emailLoading: false,
                sessionLoading: false,
                smsLoading: false,
                userDetailLoading: false,
            };

        case 'UserSettings/email/Update/Started':
            return {
                ...state,
                loading: false,
                success: true,
                message: '',
                emailLoading: true,
            };
        case 'UserSettings/sms/Update/Started':
            return {
                ...state,
                loading: false,
                success: true,
                message: '',
                smsLoading: true,
            };
        case 'UserSettings/session/Update/Started':
            return {
                ...state,
                loading: false,
                success: true,
                message: '',
                sessionLoading: true,
            };
        case 'UserSettings/Update/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
                message: '',
                emailLoading: false,
                smsLoading: false,
                sessionLoading: false,
                loggedInUser: {
                    ...state.loggedInUser,
                    notification: {
                        emailenabled: action.payload.notify,
                        smsenabled: action.payload.sms,
                    },
                    session: { sessionEnabled: action.payload.session },
                },
            };
        case 'UserSettings/userDetails/Update/Started': {
            return {
                ...state,
                updateSuccess: false,
                userDetailLoading: true,
            };
        }
        case 'UserSettings/userDetails/Succeeded': {
            return {
                ...state,
                updateSuccess: true,
                userDetailLoading: false,
                loggedInUser: {
                    ...state.loggedInUser,
                    user: {
                        fName: action.payload.fName,
                        lName: action.payload.lName,
                        phone: action.payload.phone,
                        email: action.payload.email,
                    },
                },
            };
        }
        case 'UserSettings/Update/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                message: '',
                updateSuccess: false,
                userDetailLoading: false,
            };

        case 'UserSettings/ChangePassword/Succeeded':
            return {
                ...state,
                changePassword: {
                    loading: false,
                    progress: ChangePasswordDialogProgress.Succeeded,
                },
            };
        case 'UserSettings/ChangePassword/Failed':
            return {
                ...state,
                changePassword: {
                    loading: false,
                    progress: ChangePasswordDialogProgress.Failed,
                },
            };
        case 'UserSettings/ChangePassword/Started':
        case 'UserSettings/ChangePassword/Reset':
            return {
                ...state,
                changePassword: {
                    loading: false,
                    progress: ChangePasswordDialogProgress.Initial,
                },
            };
        case 'UserSettings/UserRole/Update/Started':
            return {
                ...state,
                updateRoleLoading: true,
                updateRoleSuccess: false,
            };
        case 'UserSettings/UserRole/Update/Succeeded':
            return {
                ...state,
                updateRoleLoading: false,
                updateRoleSuccess: true,
                updatedRolesSites: action.payload.updatedRoleSite,
            };
        case 'UserSettings/UserRole/Update/Failed':
            return {
                ...state,
                updateRoleLoading: false,
                updateRoleSuccess: false,
            };
        case 'UserSettings/UserRole/Update/Unmounted':
            return {
                ...state,
                updateRoleLoading: false,
                updateRoleSuccess: false,
                updatedRolesSites: [],
            };
        default:
            return state;
    }
};
